<template>
  <div style="display: contents" :class="['action-list', { 'action-list--loading': isLoading }]">
    <slot name="top" />
    <template v-for="({ label, items }, ci) in categories">
      <strong v-if="label">{{ label }}</strong>
      <hr v-else />
      <template v-for="(item, index) in items">
        <Action
          v-if="!item.items"
          :key="placement + ci + (label || 'default') + index + 'action'"
          :value="item"
          :close="close"
          v-on="$listeners"
        />
        <ActionDropdown
          v-else
          :key="placement + ci + (label || 'default') + index + 'dropdown'"
          :value="item.items"
          :close="close"
          :label="item.name"
          :icon="item.icon || null"
          placement="left-start"
          v-on="$listeners"
        />
      </template>
    </template>
    <hr v-if="$slots.bottom && value.length" />
    <slot name="bottom" />
  </div>
</template>

<script>
import Action from './Action'
import { SortByKey } from '@/utils'

export default {
  name: 'ActionList',
  inject: ['getQuery', 'getPlacement'],
  props: {
    value: Array,
    isLoading: Boolean,
    close: Function,
  },
  computed: {
    placement() {
      return this.getPlacement()
    },
    categories() {
      const defaults = []
      const primary = []
      const imports = []
      const exports = []
      const result = this.value.reduce((res, cur) => {
        if (!cur.category) defaults.push(cur)
        else if (cur.category === 'util') primary.push(cur)
        else if (cur.category === this.$t('import')) imports.push(cur)
        else if (cur.category === this.$t('export')) exports.push(cur)
        else {
          res[cur.category] = res[cur.category] || []
          res[cur.category].push(cur)
        }

        return res
      }, {})

      return [
        { items: defaults },
        ...Object.entries(result)
          .map(([k, v]) => ({ label: k, items: v }))
          .sort(SortByKey('label')),
        { label: this.$t('import'), items: imports },
        { label: this.$t('export'), items: exports },
        { items: primary },
      ].filter(({ items }) => items.length)
    },
  },
  components: {
    Action,
    ActionDropdown: () => import('./Dropdown'),
  },
}
</script>

<style lang="scss">
.action-list {
  &--loading {
    & > .action-button-wrapper,
    & > .action-dropdown {
      visibility: hidden;
      height: 0;
    }

    & > hr,
    & > strong {
      display: none;
    }
  }

  &:not(:first-child):has(strong:first-child) {
    & > strong:first-child {
      border-top: 1px solid var(--border-color);
      padding: 0.75rem 1rem 0.25rem 1rem;
      margin-top: 0.25rem;
    }
  }
}
</style>
